const joinClassNames = (...parts) => parts.filter(Boolean).join(' ')

export default function SectionHeader({
  eyebrow = '',
  title = '',
  description = '',
  actions = null,
  className = '',
  actionsClassName = ''
}) {
  return (
    <header className={joinClassNames('gg-section-header', className)}>
      <div>
        {eyebrow ? <p className="gg-section-header__eyebrow">{eyebrow}</p> : null}
        {title ? <h2 className="gg-section-header__title">{title}</h2> : null}
        {description ? <p className="gg-section-header__description">{description}</p> : null}
      </div>
      {actions ? <div className={joinClassNames('gg-section-header__actions', actionsClassName)}>{actions}</div> : null}
    </header>
  )
}
